import { setMeta } from "@synthesis/shared-services/project-gge/projectMetaController/client";
import { createLocalProjectRole } from "@synthesis/shared-services/project-gge/role/client";
import type { GroupDto } from "@synthesis/shared-services/auth/group/types";

import type { RoleAssignmentType } from "../../list-of-experts-page/list-of-experts-page.lib";
import type { CreateProjectFormData, StepsProps } from "./create-project-schema";

export const FORM_SESSION_KEY = "data";

const STEP_TITLES = {
  info: "Внесение основной информации",
  roles: "Выбор ролей",
} as const;

export const toStepsProps = (step: 1 | 2): StepsProps =>
  step === 1
    ? {
        step1: { title: STEP_TITLES.info, status: "in_progress", isActive: true },
        step2: { title: STEP_TITLES.roles, status: "pending", isActive: false },
      }
    : {
        step1: { title: STEP_TITLES.info, status: "done", isActive: false },
        step2: { title: STEP_TITLES.roles, status: "in_progress", isActive: true },
      };

export const buildCreateProjectBody = (data: CreateProjectFormData) => ({
  title: data.name,
  objectName: data.objectName ?? "",
  description: data.description,
  realisationCost: 0,
  projectCostAtStart: 0,
  totalCost: 0,
  type: "SIMPLE" as const,
  meta: [{ key: "externalId", value: data.code }],
});

export const assignExpertsAndOwnerGroup = async (
  projectId: string,
  users: RoleAssignmentType[] | null,
  groups: GroupDto[] | null,
  userGroupId?: string,
) => {
  if (users) {
    for (const { userId } of users) {
      if (userId) {
        await createLocalProjectRole({ path: { projectId }, body: { name: "Балансодержатель" }, query: { userId } });
      }
    }
  }

  if (!groups?.length && !userGroupId) return;

  const groupIds = (groups?.map((group) => group.id).filter(Boolean) ?? []) as string[];
  if (userGroupId) groupIds.push(userGroupId);

  await setMeta({
    path: { projectId, key: "ownerGroup" },
    body: {
      key: "ownerGroup",
      value: JSON.stringify(groupIds),
    },
  });
};

export const getCreateProjectErrorMessage = (error: unknown): string => {
  if (error && typeof error === "object" && "response" in error) {
    return String((error as { response?: { data?: { message?: string } } }).response?.data?.message ?? "");
  }
  return error instanceof Error ? error.message : "";
};

export const expertsSelectionIsValid = (users: RoleAssignmentType[] | null): boolean => !users?.length || users.every((user) => user.userId);
